import { render, staticRenderFns } from "./SettingsProfile.vue?vue&type=template&id=b407c5a6&scoped=true"
import script from "./SettingsProfile.vue?vue&type=script&lang=js"
export * from "./SettingsProfile.vue?vue&type=script&lang=js"
import style0 from "./SettingsProfile.vue?vue&type=style&index=0&id=b407c5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b407c5a6",
  null
  
)

export default component.exports